module.exports = __webpack_public_path__ + "static/media/ecommerce-header.7cdeae31.jpg";